<template>
    <button 
        type="button"
        class="o-searchbar-item-otg"
        @click="onClick"
    >   
        <div
            
            class="searchbar-item-logo"
            :style="{backgroundImage: `url(${icon})`}"
        />
        <div class="searchbar-item-info">
            <span class="searchbar-item-title">
                {{ title }}
            </span>
            <span class="searchbar-item-floor">
                {{ floor }}
            </span>
        </div>
    </button>
</template>

<script>
export default {
    name: 'OSearchbarItemOtg',
    props: {
        title: {
            type: String,
            default: ''
        },
        floor: {
            type: String,
            default: ''
        },
        id: {
            type: Number,
            default: 0
        },
        icon: {
            type: String,
            default: ''
        }
    },
    setup(props, { emit }) {
        function onClick() {
            emit('onClick', props.id)
        }

        return {
            onClick
        };
    }
}
</script>

<style lang="scss" src="./theme.scss" />
